import { getAuth } from 'firebase/auth';
import React, { useEffect } from 'react'
import Button from 'react-bootstrap/Button';
import LogOut from '../Components/LogOut';
import MainNav from '../Components/Navbar';
import LogoQualy from '../Components/LogoQualy';
import { Col, Container, Row, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router';


function Home(props) {

  useEffect(() => {
  }, [])

  return (
    <>
      <MainNav />
      <Container>
        <Row className='justify-content-center'>
          <Col md={6} className=''>
            <LogoQualy className="w-100 d-flex justify-content-center my-5" />
          </Col>
        </Row>

      </Container>
    </>
  )
}

export default Home